<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="tab.distributionContainerConfig" mode="text" status="primary"/>
      </template>
      <template #extra>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="refresh(warehouse)"/>
        <vxe-button content="button.add" icon="vxe-icon-add" mode="text" status="primary" @click="add"/>
      </template>
      <vxe-table ref="table" :data="list" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:flowTypes}" field="flowType" title="business.label.flowType"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:packTypes}" field="packType" title="business.label.packType"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:distributionTypes}" field="distributionType" title="business.label.distributionType"/>
        <vxe-column field="containerType.name" title="business.label.containerType"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row,false)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="edit(row,true)"/>
            <vxe-button content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
    </vxe-card>
    <vxe-modal v-model="visible" :loading="loading" :title="$t('tab.distributionContainerConfig')" type="confirm" width="30%" @confirm="confirm">
      <vxe-form ref="form" :data="config" :rules="rules" span="12">
        <vxe-form-item :item-render="{name:'VxeSelect',options:flowTypes}" field="flowType" title="business.label.flowType"/>
        <vxe-form-item :item-render="{name:'VxeSelect',options:containerTypes,events:{change:()=>onContainerTypeChange}}" field="containerType.id" title="business.label.containerType"/>
        <vxe-form-item :item-render="{name:'VxeSelect',options:packTypes}" field="packType" title="business.label.packType"/>
        <vxe-form-item :item-render="{name:'VxeSelect',options:distributionTypes}" field="distributionType" title="business.label.distributionType"/>
      </vxe-form>
    </vxe-modal>
  </div>
</template>

<script>
import { deleteOne, findAll, findOne, save } from '@/api/Api'
import { Warehouse } from '@/api/dto/common/Warehouse'
import { DistributionContainerConfig } from '@/api/dto/config/DistributionContainerConfig'
import { ContainerType } from '@/api/dto/common/ContainerType'

export default {
  props: {
    flowTypes: { type: Array, default: [] },
    packTypes: { type: Array, default: [] },
    distributionTypes: { type: Array, default: [] },
    containerTypes: { type: Array, default: [] }
  },
  data() {
    return {
      loading: false,
      visible: false,
      warehouse: new Warehouse(),
      list: [],
      config: new DistributionContainerConfig(),
      rules: {
        flowType: [{ required: true, type: 'string', message: this.$t('message.cannotBeEmpty') }],
        'containerType.id': [{ required: true, type: 'string', message: this.$t('message.cannotBeEmpty') }]
      }
    }
  },
  methods: {
    onContainerTypeChange(event) {
      this.config.containerType = new ContainerType({ id: event.value })
    },
    refresh(warehouse) {
      this.warehouse = warehouse
      if (this.warehouse.isNew()) {
        return this.$message.warning('请先选择仓库')
      }
      this.loading = true
      findAll('distributionContainerConfigFactory', { 'warehouse.id': this.warehouse.id }).then(res => {
        if (res.success) {
          this.list = res.result.map(item => {
            return new DistributionContainerConfig(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.visible = true
      this.config = new DistributionContainerConfig()
    },
    edit(row, copy) {
      this.visible = true
      this.loading = true
      findOne('distributionContainerConfigFactory', { id: row.id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.config = new DistributionContainerConfig(res.result)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.loading = true
      const config = this.config.toJSONObject()
      config.warehouse = this.warehouse
      save('distributionContainerConfigPersister', config).then(res => {
        if (res.success) {
          this.config = new DistributionContainerConfig(res.result)
          this.$message.success(this.$t('message.saveSuccess'))
          this.refresh(this.warehouse)
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    async confirm() {
      if (!await this.$refs.form.validate()) this.save()
    },
    remove(row) {
      if (row.id) {
        this.loading = true
        deleteOne('distributionContainerConfigDeleter', { id: row.id }).then(res => {
          if (res.success) {
            this.refresh(this.warehouse)
            this.$message.success(this.$t('message.deleteSuccess'))
          }
        }).finally(() => this.loading = false)
      } else {
        this.list.splice(this.list.indexOf(row), 1)
      }
    }
  }
}
</script>